var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2188 2.5H3.21875C2.66647 2.5 2.21875 2.94772 2.21875 3.5V15.5C2.21875 16.0523 2.66647 16.5 3.21875 16.5H15.2188C15.771 16.5 16.2188 16.0523 16.2188 15.5V3.5C16.2188 2.94772 15.771 2.5 15.2188 2.5ZM3.21875 0.5C1.5619 0.5 0.21875 1.84315 0.21875 3.5V15.5C0.21875 17.1569 1.5619 18.5 3.21875 18.5H15.2188C16.8756 18.5 18.2188 17.1569 18.2188 15.5V3.5C18.2188 1.84315 16.8756 0.5 15.2188 0.5H3.21875ZM9.21875 12.5C10.8756 12.5 12.2188 11.1569 12.2188 9.5C12.2188 7.84315 10.8756 6.5 9.21875 6.5C7.5619 6.5 6.21875 7.84315 6.21875 9.5C6.21875 11.1569 7.5619 12.5 9.21875 12.5ZM9.21875 14C11.704 14 13.7188 11.9853 13.7188 9.5C13.7188 7.01472 11.704 5 9.21875 5C6.73347 5 4.71875 7.01472 4.71875 9.5C4.71875 11.9853 6.73347 14 9.21875 14ZM14.177 6C14.7293 6 15.177 5.55228 15.177 5C15.177 4.44772 14.7293 4 14.177 4C13.6247 4 13.177 4.44772 13.177 5C13.177 5.55228 13.6247 6 14.177 6Z",
    fill: "#B1924C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.4eb36a9e219e29379743f9e5ccf75a19.svg";
export { ForwardRef as ReactComponent };